import { DEFAULT_PAGE_SIZE } from 'consts/placeholders';
import API from 'services/api';

export const getAllUsersFilter = () => {
  return API.get('/api/users', { params: { PageNo: 1, PageSize: DEFAULT_PAGE_SIZE } }).then(
    response => response?.data,
  );
};
